import { Status, Tooltip } from '@mm/components';
import { TokenErrorInfo, tokenErrorMsg } from '@mm/state/model/ConnectionModel';
import classNames from 'classnames';
import React from 'react';
import { colors } from '../../../../../styles/colors';

type Props = {
  styles: any;
  token?: { errorInfo: TokenErrorInfo; missingScopes: string[] };
};

export const OauthTokenStatus = ({ token, styles }: Props) => {
  const missingScopes = token?.missingScopes || [];
  return token?.errorInfo ? (
    <Tooltip
      anchorElement={
        <Status
          status="Failed to connect"
          color={colors.dustRed}
          className={classNames(styles.oauthStatus, styles.oauthStatusError)}
        />
      }
      useHover
      css={{
        container: styles.tooltipContainer,
      }}
      withoutLine
      position="top"
    >
      {tokenErrorMsg('oauthToken', token.errorInfo)}
    </Tooltip>
  ) : missingScopes.length > 0 ? (
    <Tooltip
      anchorElement={
        <Status
          status="Connected"
          color={colors.orange}
          className={classNames(styles.oauthStatus, styles.oauthStatusWarn)}
        />
      }
      useHover
      css={{
        container: styles.tooltipContainer,
      }}
      withoutLine
      position="top"
    >
      {`Some of the scopes the application requires are missing:
          ${missingScopes.join('; ')}`}
    </Tooltip>
  ) : (
    <Status
      status="Connected"
      color={colors.polarGreen}
      className={classNames(styles.oauthStatus, styles.oauthStatusSuccess)}
    />
  );
};
